import { useCallback, useRef } from 'react'

import { useCustomerProductTourStatus } from 'hooks/useCustomerProductTourStatus'
import { useLoggedInUser } from 'hooks/useLoggedInUser'

export const useCustomScreensaverModal = () => {
  const { userData } = useLoggedInUser()
  const { updateProductTourStatus } = useCustomerProductTourStatus()

  const hasNotSeenBefore = useRef(
    userData?.productTourStatus?.showCustomScreensaverPromo
  )
  const shouldShowCustomScreensaverModal = Boolean(hasNotSeenBefore.current)

  const disableCustomScreensaverPromoModal = useCallback(async () => {
    await updateProductTourStatus({ showCustomScreensaverPromo: false })
  }, [updateProductTourStatus])

  return {
    shouldShowCustomScreensaverModal,
    disableCustomScreensaverPromoModal,
  }
}
